import { render, staticRenderFns } from "./Vault1.vue?vue&type=template&id=90ea258e&"
import script from "./Vault1.vue?vue&type=script&lang=js&"
export * from "./Vault1.vue?vue&type=script&lang=js&"
import style0 from "./Vault1.vue?vue&type=style&index=0&id=90ea258e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports